import { ApiClient } from '../apiClient';
import { CategoryModel } from '../types';

export class CategoriesService {
  private static readonly BASE_PATH = '/categories';

  /**
   * Get all categories
   */
  public static async getCategories(): Promise<CategoryModel[]> {
    try {
      const response = await ApiClient.get<CategoryModel[]>(this.BASE_PATH);
      
      if (!response.data) {
        throw new Error('Failed to fetch categories');
      }
      
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  }

  /**
   * Get a single category by ID
   */
  public static async getCategory(id: string): Promise<CategoryModel> {
    try {
      const response = await ApiClient.get<CategoryModel>(`${this.BASE_PATH}/${id}`);
      
      if (!response.data) {
        throw new Error(`Failed to fetch category with ID: ${id}`);
      }
      
      return response.data;
    } catch (error) {
      console.error(`Error fetching category with ID ${id}:`, error);
      throw error;
    }
  }

  /**
   * Create a new category
   */
  public static async createCategory(category: Partial<CategoryModel>): Promise<CategoryModel> {
    try {
      const response = await ApiClient.post<CategoryModel>(this.BASE_PATH, category);
      
      if (!response.data) {
        throw new Error('Failed to create category');
      }
      
      return response.data;
    } catch (error) {
      console.error('Error creating category:', error);
      throw error;
    }
  }

  /**
   * Update an existing category
   */
  public static async updateCategory(id: string, category: Partial<CategoryModel>): Promise<CategoryModel> {
    try {
      const response = await ApiClient.put<CategoryModel>(`${this.BASE_PATH}/${id}`, category);
      
      if (!response.data) {
        throw new Error(`Failed to update category with ID: ${id}`);
      }
      
      return response.data;
    } catch (error) {
      console.error(`Error updating category with ID ${id}:`, error);
      throw error;
    }
  }

  /**
   * Delete a category
   */
  public static async deleteCategory(id: string): Promise<void> {
    try {
      await ApiClient.delete(`${this.BASE_PATH}/${id}`);
    } catch (error) {
      console.error(`Error deleting category with ID ${id}:`, error);
      throw error;
    }
  }
} 